import { Type } from "../Type";
export function boolean(booleanValue) {
    return new IslyBoolean(booleanValue);
}
export class IslyBoolean extends Type {
    booleanValue;
    class = "boolean";
    constructor(booleanValue) {
        super(booleanValue == undefined ? "boolean" : booleanValue ? "true" : "false");
        this.booleanValue = booleanValue;
    }
    is = (value) => typeof value == "boolean" && (this.booleanValue == undefined || value == this.booleanValue);
}
//# sourceMappingURL=index.js.map